/**
 * Words typed or picked outside the composer (a suggestion chip, an action of « Ta journée », a page that hands a
 * sentence to the agent): put in the conversation's composer, or sent through its own send path (optimistic bubble,
 * retry). When the conversation is on screen they reach it at once; otherwise they wait in memory until it loads (a
 * reload forgets them).
 */
type Handoff = { text: string; send: boolean };

let pending: Handoff | null = null;
let live: ((h: Handoff) => void) | null = null;

export function handOffToChat(text: string, send: boolean): void {
  const t = text.trim();
  pending = t ? { text: t, send } : null;
}

export function takeChatHandoff(): Handoff | null {
  const p = pending;
  pending = null;
  return p;
}

/** The conversation on screen takes words directly (returns the unregister function). */
export function registerComposer(fn: (h: Handoff) => void): () => void {
  live = fn;
  return () => {
    if (live === fn) live = null;
  };
}

/**
 * Puts `text` in the conversation: at once when it is on screen (true), else kept for when it opens (false: the
 * caller then goes to « / »).
 */
export function composeInChat(text: string, send = false): boolean {
  const t = text.trim();
  if (!t) return true;
  if (live) {
    live({ text: t, send });
    return true;
  }
  handOffToChat(t, send);
  return false;
}
